<template>
    <div>
        <p class="puce_localisation">{{ $t('localisation.localisation')}} : 
            <span v-if="methode==='estimation'"><v-icon name='chart-bar'></v-icon>{{ $t('localisation.estime')}}</span>
            <span v-if="methode==='app'"><v-icon name='mobile'></v-icon>{{ $t('localisation.appli')}}</span>
            <span v-if="methode==='balise'"><v-icon name='satellite'></v-icon>{{ $t('localisation.balise')}}</span>
        </p>
    </div>
</template>

<script>
    export default {
        props : ["methode"],
    }
</script>

<style lang="scss" scoped>

</style>